import { useCallback } from 'react'
import { useText } from '@kkf/design'
import { GARAGE_VOCABULARY } from '../data/vocabulary'

/**
 * What a controlled value is called, in the reader's language.
 *
 * The bridge between `GARAGE_VOCABULARY` — pure data, which cannot call a hook — and the
 * listing pages that group and filter on it. Partners' and the resort's namesakes do
 * the same job for their own vocabularies.
 *
 * **It never changes the value, only the label.** `useListingFilter` compares the value
 * against `order` and against the selection; this is used where the word is rendered.
 *
 * An unrecognised value comes back as itself.
 */
export function useVocabulary(): (value: string) => string {
  const s = useText()
  return useCallback(
    (value: string) => {
      const entry = GARAGE_VOCABULARY[value]
      return entry ? s(entry) : value
    },
    [s],
  )
}
